import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'

export interface LinkWidResponse {
  sessionId: string
  sessionToken: string
  /** Opaque token used to renew this session on the next QR refresh */
  serviceId?: string
  qrCodeUrl: string
  expiresAt: string
}

export async function linkWid(
  agent: BskyAgent,
  options?: {signal?: AbortSignal; serviceId?: string; sessionId?: string},
): Promise<LinkWidResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('linkWid requires an authenticated session')
  }
  return wsocFetch<LinkWidResponse>(xrpcPath('eu.wsocial.quicklogin.linkWid'), {
    accessJwt,
    body: {
      ...(options?.serviceId && {serviceId: options.serviceId}),
      ...(options?.sessionId && {sessionId: options.sessionId}),
    },
    signal: options?.signal,
  })
}
